
import { StyleValue, defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import OfflineModal from '@/components/OfflineModal.vue';
import apmTransactions from '@/libraries/apm/transactions';
import AlertBanner from '@/components/AlertBanner.vue';
import LocationBeggingModal from './components/LocationBeggingModal.vue';
import PermissionsStepsGuide from './components/PermissionsStepsGuide.vue';
import { ActionTypes } from './store/actionTypes';
import { BannerAlert } from './store/types';

export default defineComponent({
    components: {
        OfflineModal,
        AlertBanner,
        LocationBeggingModal,
        PermissionsStepsGuide,
    },
    data(): {
        windowHeight: number | null;
    } {
        return {
            windowHeight: null,
        };
    },
    created() {
        this.windowHeight = window.innerHeight;
        window.addEventListener('resize', this.onResize);
        apmTransactions.setUserDetails();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.onResize);
        this.$store.dispatch(
            ActionTypes.STOP_WATCHING_DEVICE_LOCATION,
            undefined
        );
    },
    methods: {
        onResize() {
            this.windowHeight = window.innerHeight;
        },
    },
    computed: {
        addedVars(): StyleValue | undefined {
            const height = this.windowHeight || window.innerHeight;
            return {
                '--innerHeight': height + 'px',
            };
        },
        ...mapGetters({
            activeBannerAlert: 'getActiveBannerAlert',
            hasActiveBannerAlerts: 'hasActiveBannerAlerts',
            showLocationBeggingModal: 'showLocationBeggingModal',
            permissionsStepsGuideShown: 'getPermissionsStepsGuideShown',
        }),
        bannerAlert(): BannerAlert | undefined {
            return this.hasActiveBannerAlerts === true
                ? this.activeBannerAlert
                : undefined;
        },
    },
});
